import { Trans, useTranslation } from "react-i18next";
import ATBCard from "./ATBCard";
import asrLogo from "../resources/atbs/asr.png";
import isimLogo from "../resources/atbs/isim.png";

import "../styles/ATBsPageComponent.css";

export default function ATBsPageComponent() {
  const { t } = useTranslation();
  const atbData = [
    {
      id: "asr",
      title: t("atbs.asr.title"),
      logo: asrLogo,
      link: "https://www.asr.ro",
      content: t("atbs.asr.content", { returnObjects: true }),
    },
    {
      id: "isim",
      title: t("atbs.isim.title"),
      logo: isimLogo,
      link: "https://www.isim.ro",
      content: t("atbs.isim.content", { returnObjects: true }),
    },
  ];

  return (
    <div className="atbs-container">
      {atbData.map((atb) => (
        <ATBCard key={atb.id} title={atb.title} logo={atb.logo} link={atb.link}>
          {atb.content.map((paragraph, index) => (
            <p key={index}>
              <Trans
                i18nKey={`atbs.${atb.id}.content.${index}`}
                components={{ b: <strong /> }}
              />
            </p>
          ))}
        </ATBCard>
      ))}
    </div>
  );
}
